<template lang="pug">
div.horizontal-form
  slot
</template>

<script lang="ts">
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'HorizontalForm',
})
export default class HorizontalForm extends Vue {

}
</script>

<style scoped lang="less">
::v-deep {

}
</style>
